import styled from '@emotion/styled';

export const Divider = styled.span`
  display: flex;
  width: 1px;
  height: 32px;
  background-color: #d6dcea;
`;
